// extracted by mini-css-extract-plugin
export default {"spinner":"style_spinner__AO3V+","center":"style_center__T613x","spinnerBlade":"style_spinnerBlade__5X1es","spinner-fade":"style_spinner-fade__0sOye"};